[<RequireQualifiedAccess>]
module SongPage

open ViewTypes
open Shared
open Feliz
open Elmish
open API
open System
open Browser.Types
open Fable.Core.JS
open Fable.Core.JsInterop // needed to call interop tools
open RenderHelpers


type LocalState =
    { SelectedSong: Song
      WijzigSong: bool
      Fullscreen: bool }

let startScroll: int -> unit =
    importMember @"D:\Documenten\Programmeren\BandAid\src\Client\scroll.js"

let scrollToTop: unit -> unit =
    importMember @"D:\Documenten\Programmeren\BandAid\src\Client\scroll.js"

startScroll (0)

let startMetronome: int -> unit =
    importMember @"D:\Documenten\Programmeren\BandAid\src\Client\metronome.js"

startMetronome (0)

module Metronome =
    let mutable (bpmOn: bool) = false

    let setMetronome (songstate: ViewTypes.SongState) =
        let setinterval song =
            if song.Bpm = 0 || song.Bpm > 250 || bpmOn = false then
                startMetronome (0)
                bpmOn <- false
            else
                startMetronome (song.Bpm)

            song

        bpmOn <- not bpmOn

        Option.map setinterval songstate.SelectedSong
        |> ignore

//let init () : SongState=
//    { SelectedSong = None
//      WijzigSong = false
//      Fullscreen = false }

let update (songMsg: SongMsg) (songState: SongState) =
    let parseSpotify (spot: string) = 
        spot.Replace(@"https://open.spotify.com/track/", "spotify:track:")

    let wijzigSong songfun =
        songState.SelectedSong
        |> Option.map songfun
        |> fun selsong ->
            { songState with
                  SelectedSong = selsong }

    match songMsg with
    | UpClicked ->
        { songState with SelectedSong = None }
    | FwdClicked _ -> songState
    | BwdClicked _ -> songState
    | BPMClicked _ ->
        Metronome.setMetronome songState
        songState
    | FullScreenClicked ->
        if songState.Fullscreen then
            startScroll (0)
        else
            startScroll (1)

        { songState with
              Fullscreen = not songState.Fullscreen }
    | WijzigSongClicked ->
        match songState.SelectedSong with
        | None -> songState
        | Some _ ->
            { songState with
                  WijzigSong = true
                  Fullscreen = false }
    | BewaarSongClicked -> { songState with WijzigSong = false }
    | CancelSongClicked ->
        // als song een net nieuw gemaakte song is zonder wijzigingen, dan niet opslaan
        songState.SelectedSong
        |> Option.bind
            (fun (song: Song) ->
                if (song.Name.ToLower() + song.Artist.ToLower()) = "unknown titleunknown artist" then
                    None
                else
                    Some song)
        |> fun el ->
            { songState with
                  SelectedSong = el
                  WijzigSong = false }
    | RemoveSongClicked ->
        { songState with
              SelectedSong = None
              WijzigSong = false }
    | LyricsChanged lyrics -> wijzigSong (fun song -> { song with Content = lyrics })
    | SpotifyChanged spot ->
        wijzigSong
            (fun song ->
                { song with
                      Spotify = parseSpotify spot })
    | ArtistChanged artist -> wijzigSong (fun song -> { song with Artist = artist })
    | SongNameChanged name -> wijzigSong (fun song -> { song with Name = name })
    | BPMChanged bpm -> wijzigSong (fun song -> { song with Bpm = int bpm })

module RItems =

    // buttons
    let navBar (top: bool) (songState: LocalState) (dispatch: SongMsg->unit) =
        let song = songState.SelectedSong
        let hasSpotify = song.Spotify <> ""

        let spotbg =
            if song.Spotify <> "" then
                ""
            else
                "has-background-light"

        let btnElm (faclass: string) dispfun extraCls =
            Html.button [
                prop.className ("button level-item" + " " + extraCls)
                prop.onClick (fun _ -> dispatch dispfun)
                prop.children [
                    Html.i [ prop.className faclass ]
                ]
            ]

        let levelLeft () =

            let upBtn () = btnElm "fa fa-arrow-up" UpClicked ""

            let bwdBtn () =
                btnElm "fa fa-arrow-left" (BwdClicked song.Id) ""

            let fwdBtn () =
                btnElm "fa fa-arrow-right" (FwdClicked song.Id) ""

            let flScrnBtn () =
                let extrcls =

                    match songState.Fullscreen with
                    | false -> "has-background-white has-text-black"
                    | true -> "has-background-black has-text-white"

                btnElm "fa fa-arrows-alt" (FullScreenClicked) extrcls

            let bpmBtn () =
                let extrcls =

                    match Metronome.bpmOn with
                    | false -> "has-background-white has-text-black"
                    | true -> "has-background-black has-text-white"

                btnElm "fas fa-drum" (BPMClicked song.Id) extrcls

            let musicBtn () =
                Html.a [
                    prop.className ("button level-item" + " " + spotbg)
                    if hasSpotify then
                        prop.href song.Spotify
                    prop.children [
                        Html.i [ prop.className "fa fa-music" ]
                    ]
                ]

            [ upBtn ()
              bwdBtn ()
              fwdBtn ()
              flScrnBtn ()
              if top then
                  musicBtn ()
                  bpmBtn () ]
            |> wrapxIn Html.div "level-left"

        let levelRight () =
            btnElm "fa fa-edit" WijzigSongClicked "has-text-danger"
            |> wrap1In Html.div "level-right"

        [ levelLeft ()
          if top then levelRight () ]
        |> wrapxIn Html.div "level is-mobile"


    let viewLyrics (song: Song) = Parser.str2Formatted song.Content

    let content (songState: LocalState) (dispatch: SongMsg->unit)=
        if songState.Fullscreen then
            scrollToTop ()
            startScroll (0)
            startScroll (1)

        Html.div [
            prop.children [
                navBar true songState dispatch
                Html.strong [
                    prop.text songState.SelectedSong.Name
                ]
                viewLyrics songState.SelectedSong
                if songState.SelectedSong.Content.Length > 500 then
                    navBar false songState dispatch // bij lange tekst, ook onderaan de navigatiebuttons
            ]
        ]

module RItemsEdit =
    let buttons (dispatch: SongMsg -> unit) =
        Html.div [
            prop.className "field is-grouped is-grouped-centered"
            prop.children [
                Html.p [
                    prop.className "control"
                    prop.children [
                        Html.a [
                            prop.className "button is-primary"
                            prop.text "save"
                            prop.onClick (fun _ -> dispatch (ViewTypes.BewaarSongClicked))
                        ]
                    ]
                ]
                Html.p [
                    prop.className "control"
                    prop.children [
                        Html.a [
                            prop.className "button is-warning"
                            prop.text "cancel"
                            prop.onClick (fun _ -> dispatch (ViewTypes.CancelSongClicked))
                        ]
                    ]
                ]
                Html.p [
                    prop.className "control"
                    prop.children [
                        Html.a [
                            prop.className "button is-danger"
                            prop.text "delete"
                            prop.onClick (fun _ -> dispatch (ViewTypes.RemoveSongClicked))
                        ]
                    ]
                ]
            ]
        ]

    let HorizontalField (lbl: string) (placeholder: string) (def: string) (dispatcher: string -> unit) =
        let label () =
            Html.label [
                prop.className "label"
                prop.text lbl
            ]
            |> wrap1In Html.div "field-label is-normal"

        let body () =
            Html.input [
                prop.className "input"
                prop.type' "text"
                prop.placeholder placeholder
                prop.valueOrDefault def
                prop.onChange dispatcher
            ]
            |> wrap1In Html.div "control"
            |> wrap1In Html.div "field"
            |> wrap1In Html.div "field-body"

        [ label (); body () ]
        |> wrapxIn Html.div "field is-horizontal is-mobile"

    let editForm (song: Song) (dispatch: SongMsg -> unit) =
        let spotifyField () =
            HorizontalField "Spotify" "paste spotify link" song.Spotify (SpotifyChanged >> dispatch)

        let artistField () =
            HorizontalField "Artist" "artist" song.Artist (ArtistChanged >> dispatch)

        let nameField () =
            HorizontalField "Name" "name" song.Name (SongNameChanged >> dispatch)

        let bpmField () =
            HorizontalField "BPM" "BPM" (song.Bpm.ToString()) (BPMChanged >> dispatch)

        [ spotifyField ()
          artistField ()
          nameField ()
          bpmField () ]
        |> wrapxIn Html.div ""


    let lyricsFieldEdit (song: Song) dispatch =
        Html.textarea [
            prop.className "textarea is-family-monospace"
            prop.valueOrDefault song.Content
            prop.rows 50
            prop.onChange (LyricsChanged >> dispatch)
        ]


    let content (song: Song) dispatch =
        Html.div [
            buttons dispatch
            editForm song dispatch
            Html.br []
            lyricsFieldEdit song dispatch
        ]

let render (state: SongState) (dispatch: SongMsg -> unit) =
    match state.SelectedSong with
    | None -> Html.none
    | Some song ->
        let localstate = // om de option er uit te halen
            { LocalState.SelectedSong = song
              WijzigSong = state.WijzigSong
              Fullscreen = state.Fullscreen }

        match state.WijzigSong with
        | true -> RItemsEdit.content song dispatch
        | false -> RItems.content localstate dispatch
